import { ClientLeadTeamDto, ExternalSystem } from 'api/Clients/Types/ClientDetailedDto'
import { NameDto } from 'api/Common/Types'

import { TickmillCompanyTypes } from '../../Clients/Types/TickmillCompanyTypes'

export interface LeadDetailsDto {
  activities: {
    leadId: string
    primaryAddressCountry: string
    firstName: string
    lastName: string
    leadSource: {
      id: number
      name: string
    }
    leadSourceDescription: string
    phoneMobile: string
    title: string
    optIn: boolean
    campaignSource: string
    campaign: string
    campaignMedium: string
    campaignTerm: string
    campaignContent: string
    referrer: string
    referralCode: string
    tradingAccountLogin: string
    tradingAccountGroup: string
    tradingAccountServer: string
    sglAgent: NameDto
  }[]
  id: string
  email: string
  countryCode: string | null
  tickmillCompany: {
    shortName: string
    name: string
    id: TickmillCompanyTypes
  }
  leadSource: {
    id: number
    name: string
  }
  type: {
    name: string
    id: number
  }
  client: {
    id: string
    name: string
  } | null
  phoneNumber: string
  title: string
  firstName: string
  middleName: string
  lastName: string
  nativeName?: string | null
  birthDay: string
  country: {
    name: string
    id: string
  }
  assignee: {
    id: string
    name: string
    status?: {
      id: number
      name: string
    }
  } | null
  etdAssignee: {
    id: string
    name: string
    status?: {
      id: number
      name: string
    }
  } | null
  language: {
    name: string
    id: string
  }
  preferredCurrency: {
    name: string
    id: string
  } | null
  emailVerified: boolean
  phoneVerified: boolean
  created: string
  updated: string
  externalSystems: ExternalSystem[]
  teams: ClientLeadTeamDto[]
  products: NameDto[]
  address: string | null
  city: string | null
  isUsCitizen: boolean
  isConverted: boolean
  isActivityReset: boolean
  salesStatus: {
    id: number
    name: string
  }
  state: string | null
  street: string | null
  postalCode: string | null
  gender: {
    id: 1 | 2
    name: 'Male' | 'Female'
  } | null
}

export enum LeadIdSourceEnum {
  IsMobileRegistration = 18,
  IsLiveRegistration = 5,
}
